<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-if="boiteRecherche"
          v-model="search"
          append-icon="mdi-magnify"
          :label="labelRechercher ? labelRechercher : $tc('csqc-table.label.rechercher')"
          single-line
          outlined
          dense
          hide-details
        >
        </v-text-field>
      </v-col>

      <v-col
        cols="12"
        sm="6"
      >
        <slot name="customButtons"></slot>
        <v-btn
          v-if="btnAjouter"
          color="primary"
          class="float-right"
          @click.stop="ajouter"
        >
          {{ labelAjouter ? labelAjouter : $tc("csqc-table.button.ajouter") }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <slot name="actionsRecherche"></slot>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="colonnes"
          :items="liste"
          item-key="id"
          class="elevation-1 hyphen_auto no-sorting-arrow extra-padding"
          :loading="chargementListe"
          :search="search"
          :page.sync="page"
          :sort-by.sync="triPar"
          :items-per-page="itemsParPageTable"
          mobile-breakpoint="0"
          :sort-desc.sync="triDesc"
          :show-select="showSelect"
          v-model="selectedList"
          @page-count="pageCount = $event"
          @click:row="cliqueLigne"
          :footer-props="{
            itemsPerPageOptions: itemsParPage,
            disablePagination: true,
            firstIcon: '',
            lastIcon: '',
            prevIcon: '',
            nextIcon: '',
          }"
        >
          <template v-slot:body.prepend>
            <slot name="filtreParChamp"></slot>
          </template>

          <template
            v-for="(_, slot) of $scopedSlots"
            v-slot:[slot]="scope"
          >
            <slot
              :name="slot"
              v-bind="scope"
            ></slot>
          </template>

          <template
            v-slot:item.action="{ item }"
            class=""
          >
            <slot
              name="actionsCustom"
              v-bind:item="item"
            ></slot>
            <v-tooltip
              v-if="btnSupprimer"
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  large
                  v-on="on"
                  class="iconeSupprimer float-right"
                  @click.stop.prevent
                  @click.stop="supprimer(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span> {{texteIconSupprimer ? texteIconSupprimer : $tc("csqc-table.tooltip.supprimer") }} </span>
            </v-tooltip>

            <v-tooltip
              v-if="btnModifier"
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  ref="modifier"
                  v-bind="attrs"
                  @clic.stop.prevent
                  @click.stop="modifier(item)"
                  v-on="on"
                  large
                  class="couleurHover float-right"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span> {{ texteIconModifier ? texteIconModifier : $tc("csqc-table.tooltip.ouvrirItem") }} </span>
            </v-tooltip>

          </template>
        </v-data-table>

        <div class="text-center pt-2">
          <v-pagination
            v-model="page"
            :length="pageCount"
          > </v-pagination>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import "../CsqcGlobals/CSQC.css";
export default {
  props: {
    labelRechercher: {
      type: String
    },
    labelAjouter: {
      type: String
    },
    texteIconSupprimer: {
      type: String
    },
    texteIconModifier: {
      type: String
    },
    liste: {
      type: Array,
    },
    colonnes: {
      type: Array,
    },
    itemsParPage: {
      type: Array,
      default: () => [10, 25, 30, -1],
    },
    itemsParPageTable: {
      type: Number,
      default: () => 10,
    },

    boiteRecherche: {
      type: Boolean,
      default: true,
    },
    showSelect: {
      type: Boolean,
      default: false,
    },
    btnAjouter: {
      type: Boolean,
      default: true,
    },
    btnModifier: {
      type: Boolean,
      default: true,
    },
    btnSupprimer: {
      type: Boolean,
      default: true,
    },
    chargementListe: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      selectedList: [],
      page: 1,
      pageCount: 0,
      titre: "",
      triPar: ["text"],
      triDesc: [false],
      search: "",
    };
  },
  created() { },
  watch: {
    selectedList: function () {
      this.$emit("update:selectedList", this.selectedList);
    },
  },
  methods: {
    // updateSelect(selected){
    //   console.log('un test avec un objet test',test);
    //   console.log('liste: ', this.selectedList);
    // },
    // selectAll(lstSelected){

    // },
    modifier(item) {
      if (!this.btnModifier) return;

      this.$emit("modifier", item);
    },
    cliqueLigne(item) {
      if (!this.btnModifier) return;

      this.$emit("cliqueLigne", item);
    },
    ajouter() {
      if (!this.btnAjouter) return;

      this.$emit("ajouter");
    },
    supprimer(item) {
      if (!this.btnSupprimer) return;

      this.$emit("supprimer", item);
    },
  },
  computed: {
    // Pour la recherche par champs
    // inscriptionsFiltrer() {
    //   let inscriptions = this.inscriptions;
    //   if (this.headerSearch.cours != null && this.headerSearch.cours.length > 0) {
    //     inscriptions = inscriptions.filter((x) =>
    //       x.cours.titre.toLowerCase().includes(this.headerSearch.cours.toLowerCase())
    //     );
    //   }
    //   if (
    //     this.headerSearch.matiereOfficielle != null &&
    //     this.headerSearch.matiereOfficielle.length > 0
    //   ) {
    //     inscriptions = inscriptions.filter((x) =>
    //       x.cours.codeMatiere
    //         .toLowerCase()
    //         .includes(this.headerSearch.matiereOfficielle.toLowerCase())
    //     );
    //   }
    //   return inscriptions;
    // },
  },
};
</script>

<style></style>
